module.exports = __webpack_public_path__ + "images/1ce215f9630ea1459992c2214673906f-golden_badge.png";